import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

let echoInstance = null;

export function initializeEcho() {
    if (typeof window !== 'undefined') {
        if (!window.Pusher) {
            window.Pusher = Pusher;
        }
        if (!window.Echo) {
            window.Echo = new Echo({
                broadcaster: 'reverb',
                key: import.meta.env.VITE_REVERB_APP_KEY,
                wsHost: import.meta.env.VITE_REVERB_HOST,
                wsPort: parseInt(import.meta.env.VITE_REVERB_PORT || '80', 10),
                wssPort: parseInt(import.meta.env.VITE_REVERB_PORT || '443', 10),
                forceTLS: (import.meta.env.VITE_REVERB_SCHEME || 'https') === 'https',
                enabledTransports: ['ws', 'wss'],
            });
        }
        echoInstance = window.Echo;
    }
    return echoInstance;
}

export default echoInstance;
